<div class="outer-container">

    <div id="file-upload" style="margin-bottom: 20px">
        <h3>{{ 'UploadQueue' | translate }}</h3>
        <div>
            <table *ngIf="filesView" [ngClass]="{'popup-custom-class': externalPage !== 'incoming'}" aria-label="file upload" class="table">
                <thead>
                    <tr>
                        <th>{{ 'Name' | translate }}</th>
                        <th>{{ 'LesionSize' | translate}}</th>
                        <th>{{ 'Progress' | translate }}</th>
                        <th>{{ 'Status' | translate}}</th>
                        <th>{{ 'Actions' | translate}}</th>
                    </tr>
                </thead>
                <tbody [ngClass]="{'fixed-height': filesView.length > 3 && externalPage !== 'incoming'}">
                    <tr (rowFileClicked)="rowClicked(i, $event)" *ngFor="let file of filesView; let i=index"
                        [disableAllButtonsRow]="formData?.invalid"
                        [fileView]="file"
                        [loadSuccess]="loadSuccess"
                        file-loaded>
                    </tr>
                </tbody>
            </table>
        </div>

        <div>
            <div>
                <p class="queue-progress">{{ 'QueueProgress' | translate }} : {{filesToUpload}}</p>
                <div class="progress">
                    <mat-progress-bar *ngIf="uploadProgress"
                                      [value]="uploadProgress"
                                      class="progress-bar"
                                      mode="determinate">

                    </mat-progress-bar>
                </div>
            </div>
            <div class="btn-all-container">
                <button (click)="uploadAll()" [disabled]="formData?.invalid || !multipleActionAllowed()" class="btn btn-primary btn-s"
                        type="button">
                    <span class="glyphicon glyphicon-upload"></span> {{ 'UploadAll' | translate }}
                </button>
                <button (click)="deleteAll()" [disabled]="formData?.invalid || !multipleActionAllowed()" class="btn btn-primary btn-s"
                        type="button">
                    <span class="glyphicon glyphicon-trash"></span> {{ 'RemoveAll' | translate }}
                </button>
                <button *ngIf="externalPage !== 'incoming'" (click)="closeModal()" class="btn btn-primary btn-s"
                        type="button">
                    {{ 'Close' | translate }}
                </button>
            </div>

        </div>
    </div>
</div>
